import { TermsOfService } from '../components/policy-modal';
import { Footer } from '../components/footer';
import { Navigation } from '../components/navigation';
import { MetaFunction } from '@remix-run/cloudflare';

export const meta: MetaFunction = () => {
  return [
    { title: 'Terms of Service - Kumbh Sukrit' },
    {
      name: 'description',
      content:
        'View our terms of service for Kumbh Sukrit eco-village at Magh Mela 2026.',
    },
    {
      tagName: 'link',
      name: 'canonical',
      href: 'https://kumbhsukrit.com/terms-of-service',
    },
  ];
};

export default function TermsOfServicePage() {
  return (
    <div className="w-full bg-gradient-to-b from-green-100 via-white to-emerald-50 min-h-screen">
      <Navigation />
      <PolicyHeader title="Terms of Service" />
      <main className="max-w-4xl mx-auto px-6 sm:px-12 py-16 md:py-24">
        <TermsOfService />
      </main>
      <Footer />
    </div>
  );
}

const PolicyHeader = ({ title }: { title: string }) => {
  return (
    <section className="w-full relative h-[200px] md:h-[280px] bg-gradient-to-r from-emerald-800 to-emerald-600">
      <div className="absolute inset-0 flex flex-col justify-center items-center px-6">
        <span className="inline-block px-4 py-1.5 bg-white/20 text-white rounded-full text-sm font-medium mb-4">
          Legal
        </span>
        <h1 className="text-white font-bold text-3xl md:text-4xl lg:text-5xl font-display text-center">
          {title}
        </h1>
      </div>
    </section>
  );
};
